import { useLayout } from './useLayout';

export function useMobile(): boolean {
  const { isMobile } = useLayout();

  return isMobile;
}
